import { render, staticRenderFns } from "./SubmitMinReleaseSchedules.vue?vue&type=template&id=d5480af2&scoped=true&"
import script from "./SubmitMinReleaseSchedules.vue?vue&type=script&lang=js&"
export * from "./SubmitMinReleaseSchedules.vue?vue&type=script&lang=js&"
import style0 from "./SubmitMinReleaseSchedules.vue?vue&type=style&index=0&id=d5480af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5480af2",
  null
  
)

export default component.exports